import { Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import type { ProjectDetailDTO } from "@app-factory/shared";
import { api } from "@/lib/api";
import { cs } from "@/i18n/cs";
import { EmptyState, Panel } from "@/design/primitives";
import { GoalCard } from "../../goals/GoalsPage";

/** PROJECT GOALS TAB dle /Design: goal karty s iniciativami. */
export function ProjectGoalsTab({ project }: { project: ProjectDetailDTO }) {
  const goals = useQuery({ queryKey: ["goals"], queryFn: api.goals });
  const projectGoals = (goals.data?.goals ?? []).filter((g) => g.projectId === project.id);

  return (
    <div className="mt-4">
      <div className="mb-3 flex flex-wrap justify-between gap-2">
        <span className="af-label-dim">{cs.goals.projectGoalsTitle}</span>
        <Link to="/goals" className="text-[11px]" style={{ color: "var(--accent)" }}>
          {cs.goals.globalGoals}
        </Link>
      </div>
      <div className="flex max-w-[820px] flex-col gap-3">
        {projectGoals.map((g) => (
          <GoalCard key={g.id} goal={g} compact />
        ))}
        {projectGoals.length === 0 ? (
          <Panel className="p-8">
            <EmptyState title={cs.goals.empty} note="Goals zakládá owner v globálních Goals." />
          </Panel>
        ) : null}
      </div>
    </div>
  );
}
